export default __webpack_public_path__ + "static/media/deep_bite.b9973b46.png";